module.exports = __webpack_public_path__ + "img/12.ffe0254d.jpg";